import { useFetch } from './useFetch'
import type { InventorySystemProfileToVenueDTO } from '../types'

export function useInventorySystemProfileToVenues() {
  const { data: mappings, isLoading, error } =
    useFetch<InventorySystemProfileToVenueDTO[]>('/v1/inventory-system-profile-to-venues', [])
  return { mappings, isLoading, error }
}
